import { Button } from '@mui/material';
import { IRelateMasterDataFormValues } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider/types';
import { useFormContext } from 'react-hook-form';
import { OTHER_RISKS_ID } from './ModalRiskRelatedCheckboxList';
import { useMemo } from 'react';
import { checkMessageEn } from '@Utils/validation';

type ConfirmUpdateRelateRiskType = {
  onUpdateRisks: (values: IRelateMasterDataFormValues[]) => void;
  close: () => void;
};

const ConfirmUpdateRelateRisk = (props: ConfirmUpdateRelateRiskType) => {
  const { onUpdateRisks, close } = props;
  const { getValues, watch } = useFormContext();

  const allRisks = watch();
  const hasRelateRiskInitialValues = useMemo(() => {
    const allOtherDone: Array<boolean> = [];

    const selectedRisks = Object.keys(allRisks).filter((risk) => {
      const riskItem = allRisks[risk];
      const isOther = Object.values(OTHER_RISKS_ID).includes(
        riskItem.infoCategoryMasterDataId
      );

      if (isOther && riskItem.checked) {
        const { nameTh, nameEn } = riskItem;
        const hasMessageTh = nameTh && nameTh.trim() !== '';
        const hasMessageEn = nameEn && nameEn.trim() !== '';
        if (hasMessageTh && hasMessageEn && checkMessageEn(nameEn)) {
          allOtherDone.push(true);
        } else {
          allOtherDone.push(false);
        }
      }

      if (riskItem.checked) return true;
      return false;
    });

    return allOtherDone.every((risk) => risk) && selectedRisks.length > 0;
  }, [allRisks]);

  const handleSubmit = () => {
    const allRisks = getValues();

    const selectedRisks: IRelateMasterDataFormValues[] = [];

    Object.keys(allRisks).map((risk) => {
      if (allRisks[risk].checked) {
        const isOther = Object.values(OTHER_RISKS_ID).includes(
          allRisks[risk].infoCategoryMasterDataId
        );
        return selectedRisks.push({
          infoCategoryMasterDataId: allRisks[risk].infoCategoryMasterDataId,
          nameTh: isOther ? allRisks[risk].nameTh : undefined,
          nameEn: isOther ? allRisks[risk].nameEn : undefined,
        });
      }
      return undefined;
    });

    onUpdateRisks(selectedRisks);
    close();
  };

  return (
    <Button onClick={handleSubmit} disabled={!hasRelateRiskInitialValues}>
      ยืนยัน
    </Button>
  );
};

export default ConfirmUpdateRelateRisk;
